__webpack_require__.p = "../wp-content/themes/yotpo/js-static/bfcm-app/build/";